module.exports = __webpack_public_path__ + "static/specialities.d0fb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/specialities.jpg
// module id = 233
// module chunks = 105484401514700 143043459938790